import FeatureGates from "@atlaskit/feature-gate-js-client";

import { StatsigFeatureGateKey } from "../../../../../../../feature-gates/types";

export function getGupsIntegrationInJiraOnboardingEnabled() {
    return FeatureGates.checkGate(
        StatsigFeatureGateKey.JFIND_INTEGRATE_GUPS_IN_JIRA_ONBOARDING
    );
}
